import { Buttplug } from "./buttplug_ffi";
export class ButtplugError extends Error {
    constructor(aMessage, aId = 0, aInner) {
        super(aMessage);
        this.innerError = aInner;
        this.messageId = aId;
    }
}
export class ButtplugHandshakeError extends ButtplugError {
    constructor(aMessage, aId = 0) {
        super(aMessage, aId);
    }
}
export class ButtplugDeviceError extends ButtplugError {
    constructor(aMessage, aId = 0) {
        super(aMessage, aId);
    }
}
export class ButtplugMessageError extends ButtplugError {
    constructor(aMessage, aId = 0) {
        super(aMessage, aId);
    }
}
export class ButtplugPingError extends ButtplugError {
    constructor(aMessage, aId = 0) {
        super(aMessage, aId);
    }
}
export class ButtplugUnknownError extends ButtplugError {
    constructor(aMessage, aId = 0) {
        super(aMessage, aId);
    }
}
export class ButtplugClientConnectorError extends ButtplugError {
    constructor(aMessage, aId = 0) {
        super(aMessage, aId);
    }
}
export function convertPBufError(err, id) {
    if (err.errorType === Buttplug.ServerMessage.ButtplugErrorType.ButtplugConnectorError) {
        return new ButtplugClientConnectorError(err.message, id);
    }
    if (err.errorType === Buttplug.ServerMessage.ButtplugErrorType.ButtplugDeviceError) {
        return new ButtplugDeviceError(err.message, id);
    }
    if (err.errorType === Buttplug.ServerMessage.ButtplugErrorType.ButtplugHandshakeError) {
        return new ButtplugHandshakeError(err.message, id);
    }
    if (err.errorType === Buttplug.ServerMessage.ButtplugErrorType.ButtplugMessageError) {
        return new ButtplugMessageError(err.message, id);
    }
    if (err.errorType === Buttplug.ServerMessage.ButtplugErrorType.ButtplugPingError) {
        return new ButtplugPingError(err.message, id);
    }
    if (err.errorType === Buttplug.ServerMessage.ButtplugErrorType.ButtplugUnknownError) {
        return new ButtplugUnknownError(err.message, id);
    }
    throw new ButtplugUnknownError("Cannot convert error: " + err);
}
//# sourceMappingURL=errors.js.map